import type { SVGProps } from 'react';
import { useId } from 'react';

export interface SpecialOrderIconProps extends Omit<SVGProps<SVGSVGElement>, 'xmlns' | 'children'> {}

const SpecialOrderIcon = ({
  className,
  width = '20',
  height = '20',
  ...rest
}: SpecialOrderIconProps) => {
  const clipPathId = useId().replace(/:/g, '');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      {...rest}
      width={width}
      height={height}
      className={className}
      fill="none"
      aria-hidden={true}
      focusable="false"
    >
      <defs>
        <clipPath id={clipPathId}>
          <rect width="10" height="10" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
      <rect width="20" height="20" rx="10" fill="#94C947" />
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M11.25 12.5001H5V6.66675C5 6.33523 5.1317 6.01728 5.36612 5.78286C5.60054 5.54844 5.91848 5.41675 6.25 5.41675H10C10.3315 5.41675 10.6495 5.54844 10.8839 5.78286C11.1183 6.01728 11.25 6.33523 11.25 6.66675V12.5001ZM12.0833 12.5001H15V10.4167H12.0833V12.5001ZM12.9167 7.08341H12.0833V9.58341H15V9.16675C14.9993 8.61442 14.7796 8.0849 14.3891 7.69434C13.9985 7.30378 13.469 7.08408 12.9167 7.08341ZM6.27417 13.3334C6.2589 13.4018 6.2508 13.4717 6.25 13.5417C6.25 13.818 6.35975 14.083 6.5551 14.2783C6.75045 14.4737 7.0154 14.5834 7.29167 14.5834C7.56793 14.5834 7.83289 14.4737 8.02824 14.2783C8.22359 14.083 8.33333 13.818 8.33333 13.5417C8.33253 13.4717 8.32443 13.4018 8.30917 13.3334H6.27417ZM12.1075 13.3334C12.0922 13.4018 12.0841 13.4717 12.0833 13.5417C12.0833 13.818 12.1931 14.083 12.3884 14.2783C12.5838 14.4737 12.8487 14.5834 13.125 14.5834C13.4013 14.5834 13.6662 14.4737 13.8616 14.2783C14.0569 14.083 14.1667 13.818 14.1667 13.5417C14.1659 13.4717 14.1578 13.4018 14.1425 13.3334H12.1075Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default SpecialOrderIcon;
